



































































































































import {
  defineComponent,
  PropType,
  useContext,
  computed,
  ref,
  onMounted,
  watch
} from '@nuxtjs/composition-api';
import { useWmAttributes } from '@wemade-vsf/catalog/lib/runtime/product/composables/useWmAttributes';
import { SfHeading } from '@storefront-ui/vue'
import CmsContent from 'components/theme/Content/CmsContent.vue';
import ProductAttachment from 'components/catalog/Product/ProductAttachment.vue';
import ProductAttributeGroup from 'components/catalog/Product/ProductAttributeGroup.vue';
import ProductTab from 'components/catalog/Product/ProductTab.vue';
import FittingParts from '~/modules/part-finder/components/FittingParts.vue';
import type { Product, ProductAttachmentInterface } from '@wemade-vsf/catalog/lib/runtime/product/types';
import type { ComplexTextValue } from '@wemade-vsf/magento-api';

// const mobileBreakpoint = 767;

interface MenuItem {
  label: string;
  id: string;
  visible: boolean;
}

export default defineComponent({
  name: 'ProductTabs',
  props: {
    product: {
      type: [Object, null] as PropType<Product | null>
    },
    attachments: {
      type: [Array, null] as PropType<ProductAttachmentInterface[] | null>
    }
  },
  components: {
    SfHeading,
    CmsContent,
    ProductAttachment,
    ProductAttributeGroup,
    ProductTab,
    FittingParts,
    ProductLinksSlider: () => import('components/catalog/Product/ProductLinksSlider.vue')
  },
  setup (props) {
    const { app: { i18n } } = useContext();

    const { attributeGroups, productAttributes, specificationExcludeAtts } = useWmAttributes()

    const upsellProducts = computed<string[] | null>(() => props.product?.upsell_products?.length
      ? props.product.upsell_products.map(p => p?.sku || '').filter(Boolean) : null)
    const relatedProducts = computed<string[] | null>(() => props.product?.related_products?.length
      ? props.product.related_products.map(p => p?.sku || '').filter(Boolean) : null)
    const crosssellProducts = computed<string[] | null>(() => props.product?.crosssell_products?.length
      ? props.product.crosssell_products.map(p => p?.sku || '').filter(Boolean) : null)
    const serviceProducts = computed<string[] | null>(() => props.product?.service_products?.length
      ? props.product.service_products.map(p => p?.sku || '').filter(Boolean) : null)
    const productVideo = computed(() => productAttributes.value['wm_video'] ? productAttributes.value['wm_video']['value'] : null);
   
    const menuItems = computed<MenuItem[]>(() => {
      return [
        { label: i18n.t('Product description'), id: 'description', visible: true },
        { label: i18n.t('Product specifications'), id: 'specifications', visible: true },
        { label: i18n.t('Fitting for'), id: 'part-finder', visible: true },
        { label: i18n.t('Documents'), id: 'attachments', visible: !!(props.attachments && props.attachments.length) },
        { label: i18n.t('Video'), id: 'product-video', visible: !!productVideo.value },
        { label: i18n.t('Accessories'), id: 'crosssell-products', visible: crosssellProducts.value?.length ? true : false },
        { label: i18n.t('Related products'), id: 'related-products', visible: relatedProducts.value?.length ? true : false },
        { label: i18n.t('Recommended'), id: 'upsell-products',  visible: upsellProducts.value?.length ? true : false },
        { label: i18n.t('Spare parts'), id: 'service-products', visible: serviceProducts.value?.length ? true : false }
      ]
    })


    /**
     * Tabs and sections
     */
    const activeTab = ref<string | null>('description');
    const sections = ref<HTMLElement | null>(null);
    const loadSections = ref<string[]>([]);


    const productDescription = computed<ComplexTextValue>(
      () => {
        if (props.product?.configurable_product_options_selection?.variant?.description) {
          return props.product?.configurable_product_options_selection?.variant?.description
        }
        return props.product?.description || { html: '', styles: null};
      }
    );
    const filteredAttributeGroups = computed(() => {
      if (!attributeGroups.value || attributeGroups.value.length === 0) {
        return null
      }
      const groups = attributeGroups.value
      return groups.map(g => {
        let attributes = g.attributes || []
        attributes = attributes.filter(a => {
          return !!a.value && a.is_visible_on_front && !specificationExcludeAtts.includes(a.attribute_code)
        })
        return {
          ...g,
          attributes
        }
      }).filter(g => g.attributes.length)
    })

    function setActiveTab(id: string | null) {
      activeTab.value = id;
      if (id && !loadSections.value.includes(id)) {
        loadSections.value.push(id);
      }
    }

    return {
      // isMobile,
      activeTab,
      // navigationObs,
      // navigation,
      // isSticky,
      menuItems,
      sections,
      loadSections,
      productDescription,
      filteredAttributeGroups,
      setActiveTab,
      serviceProducts,
      crosssellProducts,
      upsellProducts,
      relatedProducts
    }
  }
})
